import naturalSort from "javascript-natural-sort";


function TenantLocationsCtrl($scope, $stateParams, TenantsService, LocationsService, $state, ProgressBarService) {
  "ngInject";

  let vm = this;
  $scope.tabIndex = 3;
  vm.locations = [];
  vm.searchDisabled = true;
  vm.tenantId = $stateParams.tenantId;

  let tenantPromise = TenantsService.getTenantById(vm.tenantId);
  tenantPromise.then(data => {
    vm.currentTenant = data
  });

  vm.getLocations = function (tenantId, page) {
    ProgressBarService.start();
    let locationsPromise = LocationsService.getLocationsBytenantIdPaginated(tenantId, page)
    locationsPromise.then(function (data) {
      vm.locations = data.object_list;
      vm.next = data.next;
      vm.previous = data.previous;
      ProgressBarService.complete();
    });
  };

  vm.searchAllTenantLocationsByName = (name) => {
    if (!name || name.length < 3) {
      return []
    }
    let promise = LocationsService.searchAllTenantLocationsByName(vm.tenantId, name)
    return promise.then((response) => {
      vm.searchedTenantLocations = response
      if (vm.searchedTenantLocations) {
        return vm.searchedTenantLocations.map((i) => i.customerLocationName).sort(naturalSort)
      } else {
        return []
      }
    })
    return promise.catch((response) => {
      let errorMessage = `Unable to fetch locations. Error: ${response.status}`;
      sweet.show('Oops...', errorMessage, 'error');
    })
  };

  vm.isTenantLocationValid = (name) => {
    if (!name || name.length < 3) {
      return []
    }
    let promise = LocationsService.searchAllTenantLocationsByName(vm.tenantId, name)
      .then((response) => {
        let match = response
        if (match) {
          for (let eachLocationName of match) {
            if (name === eachLocationName.customerLocationName) {
              vm.searchDisabled = false;
              vm.searchMatch = eachLocationName
              return;
            } else {
              vm.searchDisabled = true;
            }
          }
        } else {
          vm.searchDisabled = true;
        }
      })
  };

  vm.initialize = function () {
    vm.getLocations(vm.tenantId);
  };

  vm.editItem = item => {
    $state.go('main.editLocation', {locationId: item.key});
  };

  $scope.$watch('tabIndex', function (toTab, fromTab) {
    if (toTab !== undefined) {
      switch (toTab) {
        case 0:
          return $state.go('main.tenantDetails', {tenantId: $stateParams.tenantId});
        case 1:
          return $state.go('main.tenantManagedDevices', {tenantId: $stateParams.tenantId});
        case 2:
          return $state.go('main.tenantUnmanagedDevices', {tenantId: $stateParams.tenantId});
        case 3:
          return $state.go('main.tenantLocations', {tenantId: $stateParams.tenantId});
        case 4:
          return $state.go('main.tenantOverlays', {tenantId: $stateParams.tenantId});
        case 5:
          return $state.go('main.tenantLogs', {tenantId: $stateParams.tenantId});
        case 6:
          return $state.go('main.tenantProofPlay', {tenantId: $stateParams.tenantId});
      }
    }
  });

  return vm;
}

export {TenantLocationsCtrl}
